import { Container, Image, Navbar } from "react-bootstrap";
import {
  LogoFiaip,
  LogoFiaipMobile,
  LogoItas,
  UserNoBGIcon,
} from "src/assets";
import { typedMemo } from "src/types";
import { useHeader } from "./header.hook";

export const Header = typedMemo(() => {
  const {
    insured,
    t,
    showMenu,
    dropdownRef,
    toggleMenu,
    resetDossier,
    onClaimsLabelClick,
  } = useHeader();

  const Logos = (
    <div
      className="flex-md-row flex-column d-flex align-items-center"
      onClick={resetDossier}
      style={{ cursor: "pointer" }}
    >
      <Navbar.Brand>
        <Image src={LogoFiaip} height={45} className="d-none d-md-block" />
        <Image
          src={LogoFiaipMobile}
          height={20}
          className="d-block d-md-none"
        />
      </Navbar.Brand>
      <div className="navbar-separator d-none d-md-block" />
      <Navbar.Brand>
        <Image src={LogoItas} className="d-none d-md-block" />
        <Image src={LogoItas} height={35} className="d-block d-md-none" />
      </Navbar.Brand>
    </div>
  );

  const UserProfile = (
    <div className="user-profile-tag text-uppercase font-12-roman">
      <Image src={UserNoBGIcon} className="me-3" />
      {insured?.nome ?? ""}
    </div>
  );

  const ClaimsLabel = (
    <p className="text-uppercase claims-redirect" onClick={onClaimsLabelClick}>
      {t("header.claims")}
    </p>
  );

  const DropdownMenu = (
    <div ref={dropdownRef} className="position-relative d-block d-md-none">
      <div
        onClick={toggleMenu}
        className="d-flex align-items-center fw-bold cursor-pointer p-3 "
      >
        {UserProfile}
      </div>

      {showMenu && <div className="profile-dropdown-menu">{ClaimsLabel}</div>}
    </div>
  );

  return (
    <Navbar expand="lg" className="bg-ffffff header-navbar ps-md-3 pt-2 pb-2">
      <Container fluid className="justify-content-between">
        {Logos}

        <div className="d-flex flex-row gap-5">
          <div className="d-none d-md-block claims-redirect">{ClaimsLabel}</div>
          <div className="d-none d-md-block">{UserProfile}</div>
          {DropdownMenu}
        </div>
      </Container>
    </Navbar>
  );
});
